import FlashLib from "flashlib";
import LocalizationManager from "./LocalizationManager";

export default class LocalizeTextField extends FlashLib.TextField {
    constructor(data, displayData) {
        super(data, displayData);
        LocalizationManager.addTextField(this);
    }

    setTextParams(...params) {
        this.text = LocalizationManager.getLocalizedText(this.name, params);
    }

    destroy(options) {
        LocalizationManager.removeTextField(this);
        super.destroy(options);
    }
}
